import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Icon } from 'react-materialize';
import { formatNumber } from '../../helpers';
import * as actions from '../../actions';
import _ from 'lodash';
import './style.css';

class QueryDataTable extends Component {
  constructor(props) {
    super(props);
    this.renderIcon = this.renderIcon.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.fetchKeywordVolume = _.debounce((options => {
      const { queriesPaginated, country } = options;
      return this.props.fetchKeywordVolume({ queriesPaginated, country });
    }), 1000)
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.queriesPaginated   !== this.props.queriesPaginated    ||
      nextProps.isQueryActive      !== this.props.isQueryActive       ||
      nextProps.keywordVolume      !== this.props.keywordVolume       ||
      nextProps.startDate          !== this.props.startDate
    );
  }

  componentWillReceiveProps(nextProps) {
    const {
      startDate,
      endDate,
      country,
      positionFilter,
      selectedPage,
      device,
      selectedSite,
      querySortMetric,
      activeQueryPageNum,
      queries,
      queriesFiveWToggle,
      queriesPaginated
    } = nextProps;

    const diffPage                   = this.props.selectedPage       !== selectedPage;
    const diffCountry                = this.props.country            !== country;
    const diffDevice                 = this.props.device             !== device;
    const diffSite                   = this.props.selectedSite       !== selectedSite;
    const diffQuerySort              = this.props.querySortMetric    !== querySortMetric;
    const diffQueriesPaginated       = this.props.activeQueryPageNum !== activeQueryPageNum;
    const diffQueriesFiveWToggle     = this.props.queriesFiveWToggle !== queriesFiveWToggle;
    const diffPositionFilter         = this.props.positionFilter     !== positionFilter;
    const diffEndDate                = this.props.endDate            !== endDate;
    const diffStartDate              = this.props.startDate          !== startDate;

    const queriesFiveWToggleWithPagination    = queriesFiveWToggle && diffQueriesPaginated;
    const queriesPositionFilterWithPagination = positionFilter && diffQueriesPaginated;
    const queriesWithPagination               = diffQueriesPaginated && !queriesFiveWToggle && !positionFilter;

    const { $ } = window;
    // Don't run if dates are invalid i.e. endDate is before startDate
    if (endDate < startDate) {
      return;
    }

    // Don't run if the startDate or endDates aren't set up
    if (!this.props.startDate || !this.props.endDate) return;

    if (queriesFiveWToggleWithPagination) {
      // Fetch next paginated page of queries with five W filters
      this.props.fetchQueriesFiveW({ queries, queriesFiveWToggle, activeQueryPageNum });
    }

    if (queriesPositionFilterWithPagination) {
      // Fetch next paginated page of queries with position filters
      this.props.fetchQueriesPositionFilter({ queries, positionFilter, activeQueryPageNum});
    }

    if (queriesWithPagination) {
      // Fetch next paginated page of queries without filters
      // Params: queries and pageNum
      this.props.fetchQueriesPaginated({ queries, activeQueryPageNum });
    }

    if (diffQueriesFiveWToggle) {
      // Prevent the other toggle from triggering the other
      if (this.props.queriesFiveWToggle && !queriesFiveWToggle && positionFilter) {
        this.fetchKeywordVolume({ queriesPaginated, country });
        return;
      }

      // Fetch queries when query keywords toggle changes
      this.props.fetchQueriesFiveW({ queries, queriesFiveWToggle, activeQueryPageNum });

      if (positionFilter) {
        // Reset position filter selector when query toggle goes back to off
        $('select.position-select').find('option[value="false"]').prop('selected', true);
        $('select.position-select').material_select();

        this.props.getPositionFilter(false);
      }
    }

    if (diffPositionFilter) {
      // Prevent the other toggle from triggering the other
      if (this.props.positionFilter && !positionFilter && queriesFiveWToggle) {
        this.fetchKeywordVolume({ queriesPaginated, country });
        return;
      }

      // Fetch queries when positionFilter toggle changes
      this.props.fetchQueriesPositionFilter({ queries, positionFilter, activeQueryPageNum});

      if (queriesFiveWToggle) {
        // Reset queries toggle selector when query toggle goes back to off
        $('select.query-keyword-select').find('option[value="false"]').prop('selected', true);
        $('select.query-keyword-select').material_select();
        this.props.toggleQueriesFiveW(false);
      }
    }

    // Get keyword volume
    if (nextProps.queriesPaginated !== this.props.queriesPaginated) {
      this.fetchKeywordVolume({ queriesPaginated, country });
    }

    if (diffPage || diffCountry || diffDevice) {
      this.props.setQuerySortMetric(false);

      // Reset queries toggle selector when query toggle goes back to off
      $('select.query-keyword-select').find('option[value="false"]').prop('selected', true);
      $('select.query-keyword-select').material_select();
    
      // Reset position filter selector when query toggle goes back to off
      $('select.position-select').find('option[value="false"]').prop('selected', true);
      $('select.position-select').material_select();

      this.props.fetchQueries({
        startDate,
        endDate,
        sitePage: selectedPage,
        positionFilter,
        country,
        device
      });

      // Toggle queries back to false
      this.props.toggleQueriesFiveW(false);
      this.props.getPositionFilter(false);

      // Reset page number
      // this.props.getActivePageNum(1);
      this.props.getActiveQueryPageNum(1);
    }

    // if (diffCountry || diffDevice) {
    //   // Reset page number
    //   this.props.getActivePageNum(1);
    // }

    if (diffSite) {
      this.props.fetchQueries({ case: 'diffSite' });
      this.props.fetchQueryMetricsByDate();
      this.props.selectQuery();
    }

    if (diffQuerySort) {
      // Make it default DESC when a new metric is clicked
      this.props.setQueryOrderDirection();
    }

    if (nextProps.queryOrderDirection !== this.props.queryOrderDirection) {
      const { queryOrderDirection, queriesRaw, querySortMetric, activeQueryPageNum } = nextProps;
      this.props.fetchQueriesForSort({ queryOrderDirection, queriesRaw, querySortMetric, activeQueryPageNum });
    }

    // Update query table if dates change
    if (diffEndDate || diffStartDate) {
      this.props.fetchQueries({
        startDate,
        endDate,
        sitePage: selectedPage,
        positionFilter,
        country,
        device
      });
    }
  }

  renderRows() {
    const { selectedQuery, fetchQueryMetricsByDate, queriesPaginated, keywordVolume } = this.props;

    return queriesPaginated.map((query, index) => {
      const queryPage = query.keys[0];
      const { isQueryActive, selectQuery, checkQueryActive } = this.props;

      // Handle NaN cases
      const clicks = !isNaN(query.clicks) ? formatNumber(query.clicks) : null;
      const impressions = !isNaN(query.impressions) ? formatNumber(query.impressions) : null;
      const ctr = !isNaN(query.ctr) ? (query.ctr * 100).toFixed(2) : query.ctr;
      const position = !isNaN(query.position) ? query.position.toFixed(2) : query.position;

      return (
        <tr
          className={isQueryActive === queryPage ? 'tableActive' : null}
          key={queryPage}
          onClick={() => {
            selectQuery(queryPage);
            checkQueryActive(queryPage);

            if (selectedQuery === queryPage) {
              fetchQueryMetricsByDate();
              checkQueryActive();
              selectQuery();
            }
          }}
        >
          <td>{queryPage}</td>
          <td>{(() => {
            if (keywordVolume.keywordData) {
              const unformattedVolume = keywordVolume.keywordData[index] ? keywordVolume.keywordData[index]['vol'] : null;
              return formatNumber(unformattedVolume);
            } else {
              return null;
            }
          })()}</td>
          <td>{clicks}</td>
          <td>{impressions}</td>
          <td>{ctr}%</td>
          <td>{position}</td>
        </tr>
      );
    });
  }

  handleOnClick(event) {
    const metricToSort = event.target.getAttribute('value');
    this.props.setQuerySortMetric(metricToSort);
    this.props.setQueryOrderDirection(this.props.queryOrderDirection);
  }

  renderIcon(value) {
    const { querySortMetric, queryOrderDirection } = this.props;
    if (querySortMetric === value && queryOrderDirection === 'DESC') {
      return <Icon className="disable-select">keyboard_arrow_down</Icon>;
    } else if (querySortMetric === value && queryOrderDirection === 'ASC') {
      return <Icon className="disable-select">keyboard_arrow_up</Icon>;
    }
  }

  render() {
    return (
      <Table hoverable={true} responsive={true}>
        <thead>
          <tr>
            <th value="keys" onClick={this.handleOnClick}>
              <span className="filter-header" value="keys">
                Keyword {this.renderIcon('keys')}{' '}
              </span>
              {(() => {
                const { queriesRaw } = this.props;
                const queriesLength = queriesRaw.length;
                if (queriesLength > 0) {
                  return (
                    <span
                      className="new badge red hide-on-small-only"
                      data-badge-caption="total organic KW's"
                    >
                      {queriesLength}
                    </span>
                  );
                }
              })()}
            </th>
            <th>
              Volume
              <span
                  className="tooltipped"
                  data-position="top"
                  data-delay="50"
                  data-tooltip="Select a country for locale specific KW volume">
                <Icon tiny>info_outline</Icon>
              </span>
            </th>
            <th value="clicks" onClick={this.handleOnClick}>
              <span className="filter-header" value="clicks">
                Clicks {this.renderIcon('clicks')}
              </span>
            </th>
            <th value="impressions" onClick={this.handleOnClick}>
              <span className="filter-header" value="impressions">
                Impressions {this.renderIcon('impressions')}
              </span>
            </th>
            <th value="ctr" onClick={this.handleOnClick}>
              <span className="filter-header" value="ctr">
                CTR {this.renderIcon('ctr')}
              </span>
            </th>
            <th value="position" onClick={this.handleOnClick}>
              <span className="filter-header" value="position">
                Position {this.renderIcon('position')}
              </span>
            </th>
          </tr>
        </thead>

        {<tbody>{this.renderRows()}</tbody>}
      </Table>
    );
  }
}

function mapStateToProps({
  queries,
  startDate,
  endDate,
  selectedMetric,
  isQueryActive,
  selectedPage,
  country,
  positionFilter,
  queriesFiveWToggle,
  activeQueryPageNum,
  selectedSite,
  querySortMetric,
  queryLoading,
  device,
  queryOrderDirection,
  selectedQuery,
  queriesCount,
  queriesPaginated,
  queriesRaw,
  keywordVolume
}) {
  return {
    queries,
    startDate,
    endDate,
    selectedMetric,
    isQueryActive,
    selectedPage,
    country,
    positionFilter,
    queriesFiveWToggle,
    activeQueryPageNum,
    selectedSite,
    querySortMetric,
    queryLoading,
    device,
    queryOrderDirection,
    selectedQuery,
    queriesCount,
    queriesPaginated,
    queriesRaw,
    keywordVolume
  };
}

export default connect(mapStateToProps, actions)(QueryDataTable);



// WEBPACK FOOTER //
// ./src/components/Dashboard/QueryDataTable.js